// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sDCq_","colMin":"styles_colMin__3t6An"};